export const extractIds = (str) => {
    const messageIdPattern = /<[^>]+@[^>]+>|[^\s@<>]+@[^>\s]+/g;
    const matches = str.match(messageIdPattern);
    return matches ? matches : [];
};
/**
 * Finds all emails in a thread using the JWZ algorithm.
 * See: https://www.jwz.org/doc/threading.html
 */
export const findRelevantEmails = (emails, email) => {
    const imapId = email.details.imapId;
    if (imapId == null || imapId === '') {
        return [email];
    }
    const lookup = {};
    const findChild = (container, childRef) => {
        if (container.children.length === 0) {
            return false;
        }
        for (const child of container.children) {
            if (lookup[childRef] === child) {
                return true;
            }
            if (findChild(child, childRef)) {
                return true;
            }
        }
        return false;
    };
    const safeToMerge = (ref1, ref2) => {
        if (lookup[ref1] && findChild(lookup[ref1], ref2)) {
            return false;
        }
        if (lookup[ref2] && findChild(lookup[ref2], ref1)) {
            return false;
        }
        return true;
    };
    for (const email of emails) {
        if (email.details.imapId) {
            if (lookup[email.details.imapId]) {
                lookup[email.details.imapId].message = {
                    references: email.details.references
                        ? extractIds(email.details.references)
                        : [],
                    inReplyTo: email.details.inReplyTo
                        ? extractIds(email.details.inReplyTo).length > 0
                            ? extractIds(email.details.inReplyTo)[0]
                            : null
                        : null,
                    interactionId: email.id,
                };
            }
            else {
                lookup[email.details.imapId] = {
                    message: {
                        references: email.details.references
                            ? extractIds(email.details.references)
                            : [],
                        inReplyTo: email.details.inReplyTo
                            ? extractIds(email.details.inReplyTo).length > 0
                                ? extractIds(email.details.inReplyTo)[0]
                                : null
                            : null,
                        interactionId: email.id,
                    },
                    parent: null,
                    children: [],
                };
            }
            const refs = lookup[email.details.imapId].message.references;
            for (let i = 0; i < refs.length; i++) {
                const ref = refs[i];
                if (lookup[ref] == null) {
                    lookup[ref] = { parent: null, children: [], message: null };
                }
                if (refs[i - 1] != null &&
                    safeToMerge(refs[i - 1], ref) &&
                    lookup[ref].parent == null) {
                    lookup[ref].parent = lookup[refs[i - 1]];
                    lookup[refs[i - 1]].children.push(lookup[ref]);
                }
            }
            if (refs.length > 0) {
                lookup[email.details.imapId].parent = lookup[refs[refs.length - 1]];
                if (!lookup[email.details.imapId].parent.children.includes(lookup[email.details.imapId])) {
                    lookup[email.details.imapId].parent.children.push(lookup[email.details.imapId]);
                }
            }
        }
    }
    const relevantEmails = [];
    const addRoot = (container) => {
        if (container.parent != null) {
            addRoot(container.parent);
        }
        if (container.message) {
            const interaction = emails.find((inter) => inter.id === container.message.interactionId);
            if (interaction) {
                relevantEmails.push(interaction);
            }
        }
    };
    addRoot(lookup[imapId]);
    const addChildren = (container) => {
        for (const child of container.children) {
            if (child.message) {
                const interaction = emails.find((inter) => inter.id === child.message.interactionId);
                if (interaction) {
                    relevantEmails.push(interaction);
                }
            }
        }
        for (const child of container.children) {
            addChildren(child);
        }
    };
    addChildren(lookup[imapId]);
    return relevantEmails;
};
//# sourceMappingURL=thread-utils.js.map